import type { Theme } from "@mui/material"
import { AttributeValueElementProps } from "core/components/src/components/ArticleItem/Attributes/AttributeValue"
import { AttributeValueElementTheme } from "core/themes/src/definitions/components.types"

export const createAttributeValueElementTheme = (_: Theme): AttributeValueElementTheme => ({
    styleOverrides: {
        root: ({ isSelected }: AttributeValueElementProps & { theme: Theme }) => ({
            ...(isSelected && {
                backgroundColor: "#66a96b",
                "*": {
                    fontWeight: "normal",
                    letterSpacing: "0.1px",
                },
            }),
        }),
    },
})
